import { FIELD_VALUE_TYPE } from '@constants'

export const convertValueByType = (value: unknown, type: FIELD_VALUE_TYPE) => {
  switch (type) {
    case FIELD_VALUE_TYPE.INTEGER:
    case FIELD_VALUE_TYPE.DOUBLE: {
      if (value && !isNaN(Number(value))) {
        return Number(value)
      }

      return value
    }
    case FIELD_VALUE_TYPE.BOOLEAN: {
      if (value === 'true' || value === 'false') {
        return value === 'true'
      }

      return value
    }
    default:
      return value
  }
}
